import React from 'react';
import profileStyles from './UserProfile.module.scss';

const PlaceholderBadge = ({ icon, letter }: { icon?: string; letter?: string }) => (
    <span className={profileStyles.PlaceholderBadge}>
        {icon ? (
            <img src={icon} alt="" />
        ) : (
            <span className={profileStyles.PlaceholderLetter}>{letter?.trim().charAt(0).toUpperCase() || ''}</span>
        )}
    </span>
);

export default PlaceholderBadge;
